import { StyledFilterMenu } from '../../styles/FilterMenuStyles'
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { t } from 'i18next'
import { Clear, FilterList } from '@mui/icons-material'
import React from 'react'

type FilterMenuProps = {
  filter: () => void
  clear: () => void
  fullHeight?: boolean
  isLeftPadding?: boolean
}

const FilterMenu = ({
  filter,
  clear,
  children,
  fullHeight,
  isLeftPadding,
}: React.PropsWithChildren<FilterMenuProps>) => {
  const handleFilter = () => filter()
  const handleClear = () => clear()
  const isDownSm = useMediaQuery(useTheme().breakpoints.down('sm'))
  const theme = useTheme()

  return (
    <StyledFilterMenu
      sx={{
        width: { xs: '100%', md: '275px', lg: '275px' },
        maxHeight: { xs: '300px', sm: '450px', md: '600px', lg: fullHeight ? '100%' : '650px' },
      }}
    >
      <Stack sx={{ width: '100%', height: '100%', gap: 2, justifyContent: 'space-between' }}>
        <Stack gap={1} sx={{ pl: isDownSm ? 0 : isLeftPadding ? 1.5 : 0 }}>
          <Typography
            variant="h5"
            component="span"
            alignItems="center"
            color="text.highEmphasis"
            sx={{ pl: useMediaQuery(useTheme().breakpoints.down('sm')) ? theme.spacing(2) : theme.spacing(3) }}
          >
            {t('page.users.filtering.title')}
          </Typography>
        </Stack>
        <Stack
          sx={{
            justifyContent: 'flex-start',
            mb: 2,
            flexGrow: 1,
            height: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Stack
            sx={{
              height: '100%',
              gap: 2,
              justifyContent: 'flex-start',
              pr: isDownSm ? 0 : 1.5,
              pl: isDownSm ? 0 : isLeftPadding ? 1.5 : 0,
              mr: isDownSm ? 1 : 0,
            }}
          >
            {children}
          </Stack>
        </Stack>
        <Stack
          justifyContent="center"
          sx={{
            flexDirection: { xs: 'row-reverse', lg: 'column' },
            gap: { xs: 2, lg: 1 },
            pl: useMediaQuery(useTheme().breakpoints.down('sm')) ? theme.spacing(2) : theme.spacing(3),
          }}
        >
          <Button variant="contained" size="small" onClick={handleFilter}>
            <FilterList /> {t('page.users.filtering.filter')}
          </Button>
          <Button variant="text" size="small" onClick={handleClear}>
            <Clear /> {t('page.users.filtering.clear')}
          </Button>
        </Stack>
      </Stack>
    </StyledFilterMenu>
  )
}

export default FilterMenu
